import {
  fetchSingleTarget,
  deleteTarget,
  editTarget,
  postTarget,
  createTarget,
  archiveTarget,
  unArchiveTarget,
  duplicateTarget,
  validateLASDataAvailable,
} from '@/api'
import { targetRouteHandler } from '@/helpers'
import { SET_CURRENT_TARGET } from '@/appLogic/targets/currentTarget/store/actions'
import { NOTIFY_ADCITY } from '@/appLogic/workbench/common/store/actions'
import Toast from '@/components/common/toasts'

const module = 'TARGET_MANAGER_'

export const FETCH_SINGLE_TARGET = module + 'FETCH_SINGLE_TARGET'
export const FETCH_SINGLE_AUDIENCE = module + 'FETCH_SINGLE_AUDIENCE'

/**
 * Target Operations
 */
export const TOGGLE_TARGET_ARCHIVE_STATE = module + 'TOGGLE_TARGET_ARCHIVE_STATE'

/**
 * Target Manager Store
 */
export const POST_TARGET = module + 'POST_TARGET'
export const PRE_ACTIVATION_EDIT_TARGET = module + 'PRE_ACTIVATION_EDIT'
export const DELETE_TARGET = module + 'DELETE_TARGET'
export const UPDATE_TARGET = module + 'UPDATE_TARGET'
export const CREATE_TARGET = module + 'CREATE_TARGET'
export const DUPLICATE_TARGET = module + 'DUPLICATE_TARGET'
export const SET_LOADING_VALUE = module + 'SET_LOADING_VALUE'
export const SET_ACTIVATION_FAILED = module + 'SET_ACTIVATION_FAILED'
export const REMOVE_TARGET_FROM_TARGET_LIST = module + 'REMOVE_TARGET_FROM_TARGET_LIST'
export const ADD_TARGET_TO_TARGET_LIST = module + 'FORECAST_TARGET_TO_TARGET_LIST'
export const FORECAST_TARGET_TO_TARGET_LIST = module + 'FORECAST_TARGET'
export const UPDATE_TARGET_TO_TARGET_LIST = module + 'UPDATE_TARGET_TO_TARGET_LIST'
export const REFRESH_TARGET_LIST = module + 'REFRESH_TARGET_LIST'
export const ARCHIVE_TARGET = module + 'ARCHIVE_TARGET'
export const UNARCHIVE_TARGET = module + 'UNARCHIVE_TARGET'
export const REPLACE_TARGET = module + 'REPLACE_TARGET'
export const REFRESH_TABLE = module + 'REFRESH_TABLE'
export const VALIDATE_LAS_DATA_AVAILABLE = module + 'VALIDATE_LAS_DATA_AVAILABLE'
export const SET_LAS_DATA_AVAILABLE = module + 'SET_LAS_DATA_AVAILABLE'

export const CHANGED_ON_FILTER = module + 'CHANGED_ON_FILTER'
export const SET_REFRESH_TABLE_FLAG = module + 'SET_REFRESH_TABLE_FLAG'
export const SET_TARGET_STATUS = module + 'SET_TARGET_STATUS'
export const SET_COLUMN_FILTERS = module + 'SET_COLUMN_FILTERS'
export const REMOVE_COLUMN_FILTER_VALUES = module + 'REMOVE_COLUMN_FILTER_VALUES'

const actions = {
  [CHANGED_ON_FILTER](context, previousFilter) {
    context.commit(CHANGED_ON_FILTER, previousFilter)
  },
  [FETCH_SINGLE_TARGET](context, params) {
    context.commit(SET_LOADING_VALUE, true)
    // TODO need to adjust for full target
    fetchSingleTarget({ target_id: params.id })
      .then(function (response) {
        const target = response.data
        context.dispatch(SET_CURRENT_TARGET, response.data)
        context.commit(SET_LOADING_VALUE, false)
      })
      .catch(function (reason) {
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [FETCH_SINGLE_AUDIENCE](context, params) {
    // Check if we already have a pending request for this target
    const cacheKey = `audience_${params.id}`

    if (context.state.pendingRequests && context.state.pendingRequests[cacheKey]) {
      return context.state.pendingRequests[cacheKey]
    }

    const promise = new Promise((resolve, reject) => {
      fetchSingleTarget({ target_id: params.id })
        .then(response => {
          resolve(response.data)
        })
        .catch(reason => reject(reason))
        .finally(() => {
          // Clean up the pending request
          if (context.state.pendingRequests) {
            delete context.state.pendingRequests[cacheKey]
          }
        })
    })

    // Store the pending request to prevent duplicates
    if (!context.state.pendingRequests) {
      context.state.pendingRequests = {}
    }
    context.state.pendingRequests[cacheKey] = promise

    return promise
  },
  [POST_TARGET](context, target) {
    context.commit(SET_LOADING_VALUE, true)
    return postTarget(target)
      .then(function (response) {
        // for now we have to pass the target since the server repsonse is just a message
        // eslint-disable-next-line no-undef
        adobeAnalytics.generateForcast({
          username: context.rootState.auth.username,
          target: {
            name: target.display_name,
            id: target.id,
            type: target.target,
          },
        })
        context.commit(POST_TARGET, target)
        context.dispatch('workbench/' + NOTIFY_ADCITY, target.id)
        context.commit(SET_LOADING_VALUE, false)
        // Not sure if we should have this here... but it is here
        targetRouteHandler('OPEN', target)
      })
      .catch(function (reason) {
        context.commit(SET_LOADING_VALUE, false)
        context.commit(SET_ACTIVATION_FAILED, true)
      })
  },
  [VALIDATE_LAS_DATA_AVAILABLE](context, targetId) {
    context.commit(SET_LAS_DATA_AVAILABLE, true)
    context.commit(SET_LOADING_VALUE, true)
    validateLASDataAvailable(targetId)
      .then(function (response) {
        context.commit(SET_LAS_DATA_AVAILABLE, response['data']['12_months_data_available'])
        context.commit(SET_LOADING_VALUE, false)
      })
      .catch(function (reason) {
        context.commit(SET_LAS_DATA_AVAILABLE, true)
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [PRE_ACTIVATION_EDIT_TARGET](context, { originalTarget, newTarget }) {
    context.commit(SET_LOADING_VALUE, true)

    const target = Object.assign({}, originalTarget, newTarget)
    editTarget(target)
      .then(function (response) {
        const resTarget = response.data.Target
        context.commit(PRE_ACTIVATION_EDIT_TARGET, { originalTarget, newTarget: resTarget })
        context.commit(SET_LOADING_VALUE, false)
      })
      .catch(function (reason) {
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [DELETE_TARGET](context, target) {
    context.commit(SET_REFRESH_TABLE_FLAG, false)
    deleteTarget(target).then(function (response) {
      context.commit(REMOVE_TARGET_FROM_TARGET_LIST, target)
      context.commit(SET_REFRESH_TABLE_FLAG, true)
    })
  },
  [ARCHIVE_TARGET](context, target) {
    context.commit(SET_REFRESH_TABLE_FLAG, false)
    archiveTarget(target).then(function (response) {
      if (response && response.Error) {
        Toast.error({ title: 'Error has occurred', message: `${response.Error}` })
      } else {
        context.commit(TOGGLE_TARGET_ARCHIVE_STATE, target)
        context.commit(REFRESH_TARGET_LIST)
        context.commit(SET_REFRESH_TABLE_FLAG, true)
      }
    })
  },
  [UNARCHIVE_TARGET](context, target) {
    context.commit(SET_REFRESH_TABLE_FLAG, false)
    unArchiveTarget(target).then(function (response) {
      context.commit(TOGGLE_TARGET_ARCHIVE_STATE, target)
      context.commit(REFRESH_TARGET_LIST)
      context.commit(SET_REFRESH_TABLE_FLAG, true)
    })
  },
  [REFRESH_TABLE](context, value) {
    context.commit(SET_REFRESH_TABLE_FLAG, value)
  },
  [REMOVE_TARGET_FROM_TARGET_LIST](context, target) {
    context.commit(REMOVE_TARGET_FROM_TARGET_LIST, target)
  },
  [ADD_TARGET_TO_TARGET_LIST](context, target) {
    context.commit(ADD_TARGET_TO_TARGET_LIST, target)
    context.commit(REFRESH_TARGET_LIST)
    context.commit(SET_REFRESH_TABLE_FLAG, true)
  },
  [FORECAST_TARGET_TO_TARGET_LIST](context, targetId) {
    context.commit(FORECAST_TARGET_TO_TARGET_LIST, targetId)
  },
  // DEPRECATED  delete this functionality
  [UPDATE_TARGET_TO_TARGET_LIST](context, target) {
    context.commit(UPDATE_TARGET_TO_TARGET_LIST, target)
  },
  [CREATE_TARGET](context, target) {
    context.commit(SET_LOADING_VALUE, true)

    return createTarget(target)
      .then(function (response) {
        // eslint-disable-next-line no-undef
        adobeAnalytics.createTarget({
          username: target.username,
          target: {
            name: target.display_name,
            type: target.target,
            id: response.data.id,
          },
        })
        context.commit(CREATE_TARGET, response.data)
        context.commit(SET_LOADING_VALUE, false)
        return response
      })
      .catch(function (reason) {
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [DUPLICATE_TARGET](context, { target, duplicate_id }) {
    context.commit(SET_LOADING_VALUE, true)
    duplicateTarget({ target, duplicate_id })
      .then(function (response) {
        // eslint-disable-next-line no-undef
        adobeAnalytics.createTarget({
          username: target.username,
          target: {
            name: target.display_name,
            type: target.target,
            id: response.data.id,
          },
        })
        context.commit(CREATE_TARGET, response.data)
        context.commit(SET_LOADING_VALUE, false)
      })
      .catch(function (reason) {
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [REPLACE_TARGET](context, target) {
    context.commit(REPLACE_TARGET, target)
  },
  [SET_REFRESH_TABLE_FLAG](context, value) {
    context.commit(SET_REFRESH_TABLE_FLAG, value)
  },
  [SET_COLUMN_FILTERS](context, value) {
    context.commit(SET_COLUMN_FILTERS, value)
  },
  [REMOVE_COLUMN_FILTER_VALUES](context) {
    context.commit(REMOVE_COLUMN_FILTER_VALUES)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/views/audienceHub/store/actions.js